import { Slider } from "@mui/material";

const RangeSlider = ({ title, minValue, maxValue, onValueChange, step, minPossible, maxPossible, marks, ...props }) => {
  const handleChange = (_, newValue) => {
    onValueChange(newValue[0], newValue[1]);
  };

  return (
    <div className="RangeSlider flex flex-col gap-16" {...props}>
      <qds-title layer="popup" level="root" subtitle={title}></qds-title>
      <Slider
        getAriaLabel={() => title}
        value={[minValue, maxValue]}
        min={minPossible}
        max={maxPossible}
        onChange={handleChange}
        step={step}
        marks={marks}
        disableSwap
        valueLabelDisplay="on"
        sx={{
          color: "#008029",
          height: 8,
          "& .MuiSlider-rail": {
            color: "#CED3D6"
          },
          "& .MuiSlider-thumb": {
            height: 20,
            width: 20,
            backgroundColor: "#008029",
            boxShadow: "rgba(9, 11, 12, 0.12)",
            "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
              boxShadow: "inherit"
            }
          },
          "& .MuiSlider-mark": {
            display: "none"
          },
          "& .MuiSlider-markLabel": {
            color: "#676F73"
          },
          "& .MuiSlider-valueLabelOpen": {
            backgroundColor: "white",
            color: "black",
            border: "1px solid #CED3D6",
            borderRadius: "4px",
            height: 36,
            top: -12,
            padding: "0.25rem 0.5rem",
            boxShadow: "0px 8px 16px 0px rgba(9, 11, 12, 0.12)",
            "&::before": {
              border: "1px solid #CED3D6",
              borderTop: "none",
              borderLeft: "none",
              height: 16,
              width: 16
            }
          }
        }}
      />
    </div>
  );
};

export default RangeSlider;
